import React, { useContext } from "react";
import { QuizContext } from "../../App";
import * as XLSX from "xlsx/xlsx.mjs";

export const ButtonCreateQuizDownloadXLSXfile = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  const handleQuizFileDownload = () => {
    const quizRows = quizContext.state.quizRows;
    const quizTitle = quizContext.state.quizTitle.replaceAll(" ", "-");

    let wb = XLSX.utils.book_new(),
    ws = XLSX.utils.json_to_sheet(quizRows);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");
    XLSX.writeFile(wb, `${quizTitle}.xlsx`);
  }

  return (
    <>
      <div>
        *<span style={{ fontWeight: "600" }}>
          ШАГ 4:</span> Вы можете скачать квиз на свой компьютер в виде xlsx файла <span style={{ fontStyle: "italic" }}>(*необязательно)</span>
      </div>
      <div style={{
        textAlign: "center",
        marginTop: "5px"
      }}
      >
        {quizContext.state.alertStatus === "changes confirmed"
          ? <button
            className={`${theme}-main-btn`}
            onClick={handleQuizFileDownload}
          >
            СКАЧАТЬ XLSX ФАЙЛ
          </button>

          : <button
            className={`${theme}-main-btn-inactive`}
          >
            <span style={{ cursor: "crosshair" }}>
            СКАЧАТЬ XLSX ФАЙЛ
            </span>
          </button>
        }
      </div>
    </>
  )
}

export const ButtonDownloadXLSXfile = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  const handleQuizFileDownload = () => {
    const quizRows = quizContext.state.quizRows;
    const quizTitle = quizContext.state.quizTitle.replaceAll(" ", "-");

    let wb = XLSX.utils.book_new(),
    ws = XLSX.utils.json_to_sheet(quizRows);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");
    XLSX.writeFile(wb, `${quizTitle}.xlsx`);
  }

  return (
    <div style={{fontSize: "0.8rem"}}>
      Скачать квиз как xlsx файл <button
      className={`${theme}-download-btn`}
      onClick={handleQuizFileDownload}
    >
      СКАЧАТЬ
    </button>
    </div>
  )
}